import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function VisitorPortal() {
  const navigate = useNavigate();
  const [registerForm, setRegisterForm] = useState({
    name: "",
    email: "",
    phone: "",
    purpose: "",
    password: "",
  });
  const [verifyForm, setVerifyForm] = useState({
    email: "",
    otp: "",
  });
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(false);

  const saveVisitorSession = (data) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("userId", data.user.id);
    localStorage.setItem("role", data.user.role);
    localStorage.setItem("userName", data.user.name);

    if(data.user.visitorId){
      localStorage.setItem("visitorId", data.user.visitorId);
    }
  };

  const handleRegister = async () => {
    if(!registerForm.name || !registerForm.email || !registerForm.phone || !registerForm.password){
      alert("Please fill all required fields");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("name", registerForm.name);
    formData.append("email", registerForm.email);
    formData.append("phone", registerForm.phone);
    formData.append("purpose", registerForm.purpose);
    formData.append("password", registerForm.password);

    if(photo){
      formData.append("photo", photo);
    }

    try{
      const res = await API.post("/auth/visitor/register", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert(res.data.message);
      setVerifyForm({
        email: registerForm.email,
        otp: "",
      });
      setLoginForm({
        email: registerForm.email,
        password: "",
      });
      setRegisterForm({
        name: "",
        email: "",
        phone: "",
        purpose: "",
        password: "",
      });
      setPhoto(null);
    } 
    catch(err){
      alert(err.response?.data?.message || "Visitor registration failed");
    } 
    finally{
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if(!verifyForm.email || !verifyForm.otp){
      alert("Please enter email and OTP");
      return;
    }

    try{
      const res = await API.post("/auth/visitor/verify-otp", verifyForm);
      alert(res.data.message);
    } 
    catch(err){
      alert(err.response?.data?.message || "OTP verification failed");
    }
  };

  const handleResendOtp = async () => {
    if(!verifyForm.email){
      alert("Please enter your email first");
      return;
    }

    try{
      const res = await API.post("/auth/visitor/resend-otp", {
        email: verifyForm.email,
      });
      alert(res.data.message);
    } 
    catch(err){
      alert(err.response?.data?.message || "Could not resend OTP");
    }
  };

  const handleVisitorLogin = async () => {
    if(!loginForm.email || !loginForm.password){
      alert("Please enter email and password");
      return;
    }

    try{
      const res = await API.post("/auth/visitor/login", loginForm);
      saveVisitorSession(res.data);
      navigate("/visitor/pass");
    } 
    catch(err){
      alert(err.response?.data?.message || "Visitor login failed");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="mx-auto max-w-3xl space-y-8">
        <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-lg">
          <div className="mb-6 flex items-center justify-between gap-4">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">Visitor Self Registration</h2>
              <p className="mt-2 text-sm text-gray-500">Create your visitor account, verify your email, then log in to view your pass.</p>
            </div>
            {localStorage.getItem("role") === "visitor" && localStorage.getItem("token") && (
              <button
                onClick={() => navigate("/visitor/pass")}
                className="rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700"
              >
                Open My Pass
              </button>
            )}
          </div>

          <div className="grid gap-4">
            <input
              className="rounded-lg border p-3"
              placeholder="Full Name"
              value={registerForm.name}
              onChange={(e) => setRegisterForm({ ...registerForm, name: e.target.value })}
            />
            <input
              className="rounded-lg border p-3"
              placeholder="Email Address"
              value={registerForm.email}
              onChange={(e) => setRegisterForm({ ...registerForm, email: e.target.value })}
            />
            <input
              className="rounded-lg border p-3"
              placeholder="Phone Number"
              value={registerForm.phone}
              onChange={(e) => setRegisterForm({ ...registerForm, phone: e.target.value })}
            />
            <input
              className="rounded-lg border p-3"
              placeholder="Purpose of Visit"
              value={registerForm.purpose}
              onChange={(e) => setRegisterForm({ ...registerForm, purpose: e.target.value })}
            />
            <input
              type="password"
              className="rounded-lg border p-3"
              placeholder="Create Password"
              value={registerForm.password}
              onChange={(e) => setRegisterForm({ ...registerForm, password: e.target.value })}
            />

            <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-3">
              <p className="mb-2 text-sm font-medium text-gray-700">Upload Photo</p>
              <input type="file" accept="image/*" onChange={(e) => setPhoto(e.target.files[0])} />
            </div>

            <button
              onClick={handleRegister}
              disabled={loading}
              className="rounded-lg bg-blue-600 p-4 font-bold text-white hover:bg-blue-700 disabled:bg-gray-400"
            >
              {loading ? "Submitting..." : "Register Visitor"}
            </button>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg">
            <h3 className="mb-4 text-xl font-bold text-gray-800">Verify OTP</h3>
            <div className="space-y-4">
              <input
                className="w-full rounded-lg border p-3"
                placeholder="Registered Email"
                value={verifyForm.email}
                onChange={(e) => setVerifyForm({ ...verifyForm, email: e.target.value })}
              />
              <input
                className="w-full rounded-lg border p-3"
                placeholder="6 Digit OTP"
                value={verifyForm.otp}
                onChange={(e) => setVerifyForm({ ...verifyForm, otp: e.target.value })}
              />
              <button onClick={handleVerifyOtp} className="w-full rounded-lg bg-green-600 p-3 font-bold text-white hover:bg-green-700">
                Verify Email
              </button>
              <button onClick={handleResendOtp} className="w-full rounded-lg border border-gray-300 p-3 font-medium text-gray-700 hover:bg-gray-50">
                Resend OTP
              </button>
            </div>
          </div>

          <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg">
            <h3 className="mb-4 text-xl font-bold text-gray-800">Visitor Login</h3>
            <div className="space-y-4">
              <input
                className="w-full rounded-lg border p-3"
                placeholder="Email"
                value={loginForm.email}
                onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
              />
              <input
                type="password"
                className="w-full rounded-lg border p-3"
                placeholder="Password"
                value={loginForm.password}
                onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
              />
              <button onClick={handleVisitorLogin} className="w-full rounded-lg bg-gray-800 p-3 font-bold text-white hover:bg-gray-900">
                Login and View Pass
              </button>
            </div>
          </div>
        </div>

        <button onClick={() => navigate("/")} className="text-sm font-medium text-gray-600 underline hover:text-blue-600">
          Back to Staff Login
        </button>
      </div>
    </div>
  );
}

export default VisitorPortal;
